import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const FeaturedOffers120x90RootActionPath = 'core/FeaturedOffers120x90/GET';

export const FEATURED_OFFERS_120X90_GET_SUCCESS = `${FeaturedOffers120x90RootActionPath}_${SUCCESS_SUFFIX}`;
export const FEATURED_OFFERS_120X90_GET_FAILURE = `${FeaturedOffers120x90RootActionPath}_${FAILURE_SUFFIX}`;
